<template>
  <table>
    <thead>
      <tr>
        <th class="uppercase font-10px p-2" v-for="day in days" :key="day">{{ day }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="week in weeks" :key="week">
        <td v-for="day in (0).rangeTo(6)" :key="day">
          <slot :item="firstDay.clone().add(week * 7 + day - firstDay.day(), 'days')" :index="week * 7 + day - firstDay.day()" v-if="isBetween(week * 7 + day - firstDay.day(), 0, daysInMonth - 1)" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment';
import { isBetween } from '../../libraries/common';
export default {
  noExport: true,
  props: ['value'],
  data() {
    return {
      days: ['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat'],//moment.weekdays(),
      months: moment.months(),
    };
  },
  computed: {
    date() {
      return moment(this.value);
    },
    firstDay() {
      return this.date.startOf('month');
    },
    daysInMonth() {
      return this.date.daysInMonth();
    },
    weeks() {
      var numberOfWeeks = Math.ceil((this.firstDay.day() + this.daysInMonth) / 7);
      return (0).rangeTo(numberOfWeeks - 1);
    },
  },
  methods: {
    isBetween,
  },
}
</script>


<style lang="scss" scoped>
table {
  border-spacing: 0;
  border-collapse: collapse;
  th,
  td {
    border-bottom: 1px solid #979797;
    border-left: 1px solid #979797;
    border-right: 1px solid #979797;
  }
}
</style>
  